import * as I18n from 'circe/I18n';

export const getOptions = (options) => {
  const allOptions = [];
  if (Array.isArray(options)) {
    options?.map((option) => {
      allOptions.push({
        value: option,
        label: I18n.str(option, option),
      });
    });
  }
  return allOptions;
};

export const getObjectOptions = (options) => {
  const allOptions = [];
  Object.keys(options).map((key) => {
    allOptions.push({
      value: key,
      label: options[key],
    });
  });
  return allOptions;
};

export const formatSavedFilter = (localStorageName) => {
  const data = localStorage.getItem(localStorageName);
  console.log(localStorageName, { data });
  if (!data || data === 'null' || data === 'undefined') return null;
  else return data;
};
export const formatSavedFilterObject = (localStorageName) => {
  let data = localStorage.getItem(localStorageName);
  if (!data || data === 'null') return null;
  else return JSON.parse(data);
};
